<!-- eslint-disable vue/valid-template-root -->
<template>
  <div>
    <div v-for="(option, index) in localOptions" :key="index">
      <!-- If options is grouped -->
      <div v-if="groupLabel">
        <div class="v-select__group-label">{{ option[groupLabel] }}</div>
        <v-option
          v-for="(group, i) in option[groupValues]"
          :key="i"
          :value="group[optionId]"
          :disabled="group.$isDisabled"
        >
          <span>{{ group[label] }}</span>
          <span v-if="metaLabel" class="v-select__meta-label">{{  group[metaLabel] }}</span>
        </v-option>
      </div>
      <!-- If options is not grouped -->
      <v-option
        v-else
        :value="optionId ? option[optionId] : option"
        :disabled="option.$isDisabled"
      >
        <span>{{ optionId || metaLabel ? option.name : option }}</span>
        <span v-if="metaLabel" class="v-select__meta-label">{{  option[metaLabel] }}</span>
      </v-option>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      default: () => []
    },
    optionId: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    metaLabel: {
      type: String,
      default: null
    },
    groupLabel: {
      type: String,
      default: null
    },
    groupValues: {
      type: String,
      default: null
    }
  },
  data() {
    return {};
  },
  computed: {
    localOptions() {
      return this.options;
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
@import "../../sass/component.scss";

.v-select {
  &__group-label {
    color: #a6a6a6 !important;
    cursor: text;
    pointer-events: none;
    max-height: 50px;
    font-size: 0.9em;
    padding: 1rem;

    &--hidden {
      display: none;
    }
  }

  &__meta-label {
    float: inline-end;
    color: theme-color("placeholder");
  }
}
</style>
